import { Building2, ChefHat, HandPlatter, QrCode, ScanBarcode, UtensilsCrossed } from 'lucide-react'
import type { Product } from '../types'
import { MAGACIN_URLS } from './siteConfig'

export const products: Product[] = [
  {
    id: 'serve', name: 'Magacin Serve', shortName: 'Serve', href: '/serve', icon: UtensilsCrossed,
    eyebrow: 'Restaurant operations', description: 'Orders, tables, teams, and payments in one operational workspace.', accent: '#dfa344',
  },
  {
    id: 'pos', name: 'Magacin POS', shortName: 'POS', href: '/pos', icon: ScanBarcode,
    eyebrow: 'Retail checkout', description: 'Fast, dependable checkout connected to stock and daily operations.', accent: '#5b9cf5',
  },
  {
    id: 'kds', name: 'Magacin KDS', shortName: 'KDS', href: '/kds', icon: ChefHat,
    eyebrow: 'Kitchen display', description: 'A live preparation workflow for every kitchen and bar station.', accent: '#4fca8a',
  },
  {
    id: 'waiter', name: 'Magacin Waiter', shortName: 'Waiter', href: '/waiter', icon: HandPlatter,
    eyebrow: 'Mobile staff', description: 'Tables, orders, and kitchen status in your staff’s hands.', accent: '#a78bfa',
  },
  {
    id: 'connect', name: 'Magacin Connect', shortName: 'Connect', href: '/connect', icon: QrCode,
    eyebrow: 'Customer experience', description: 'QR menus, customer ordering, and digital restaurant experiences.', accent: '#ee7f63',
  },
]

export const businessPortalProduct = {
  id: 'business',
  name: 'Magacin Business Portal',
  shortName: 'Business Portal',
  href: MAGACIN_URLS.businessPortal,
  icon: Building2,
  eyebrow: 'Business management',
  description: 'Manage stores, products, staff, stock, devices, subscriptions, and business operations from one workspace.',
  accent: '#dfa344',
  external: true,
  layer: 'management',
} as const

export const getProduct = (id: Product['id']) => products.find((product) => product.id === id)!
